import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZData = z.object({
  total_alerts: z.number().optional(),
  high_alerts: z.number().optional(),
  medium_alerts: z.number().optional(),
  low_alerts: z.number().optional(),
  active_alerts: z.number().optional(),
  rtn_alerts: z.number().optional()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.optional(ZData)
})

export type AlertsCountDetails = z.infer<typeof ZData>
export type AlertsCountAPIData = z.infer<typeof ZApiResponse>

export async function getAlertCountDetails (
  deviceId: string,
  onSuccess: (AlertsCountDetails: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/alarm-service/api/v1/udp/tiq/assets/alerts/alertCounts/${deviceId}`
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
